// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPbm {
    static getAttributeTypeMap() {
        return MedicalEligibilityPbm.attributeTypeMap;
    }
}
MedicalEligibilityPbm.discriminator = undefined;
MedicalEligibilityPbm.additionalProperties = false;
MedicalEligibilityPbm.attributeTypeMap = [
    {
        "name": "exists",
        "baseName": "exists",
        "type": "boolean"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPbm.js.map